<template>
<main class="container-1-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <h2>Editar capa</h2>
    </div>

    <div class="container-body">
        <component
            v-if="currentForm"
            :is="currentForm"
            :categories="categories"
            :layerCreationMode="layer.provider.name"
            :isEdit="true"
            :initialData="layer"
        />
        <div v-else>
            Cargando información de la capa...
        </div>
    </div>
 
</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import FormularioGeoserver from "@/views/layers/addLayerForm/FormularioGeoserver";
import FormularioArcgis from "@/views/layers/addLayerForm/FormularioArcgis";

import {restLayer} from '@/components/mixin/restLayer.js'
import {restCategory} from '@/components/mixin/restCategory.js'

export default{
    name: 'LayersEdit',
    mixins: [restLayer, restCategory],
    components:{
        Breadcrumb,
        FormularioGeoserver,
        FormularioArcgis
    },
    computed: {
        currentForm() {
            if (!this.layer || !this.layer.provider || !this.layer.provider.name) return null;
            
            const formMap = {
                geoserver: "FormularioGeoserver",
                arcgis: "FormularioArcgis",
                // 'file' might be handled as geoserver in some contexts or needs a specific form?
                // Based on previous code, 'file' provider was handled with geoserver fields.
                // If provider is 'file', we might want to use FormularioGeoserver but user logic in backend 
                // seems to differentiate. However, the original Edit view allowed editing 'file' provider 
                // using geoserver-like fields (filename, workspace).
                // Let's assume 'file' also uses FormularioGeoserver for metadata editing.
                file: "FormularioGeoserver" 
            };
            return formMap[this.layer.provider.name] || null;
        },
        routesBread: function(){
          return [
              {name:'Capas', path: '/capas' },
              {name: this.layer.name, path: '/capas/' + this.$route.params.idLayer},
              {name: 'Editar capa'}
              ]
        }
    },
    mounted () {
        this.getCategoriesNoPages();
        this.getLayer();
    }
}
</script>

<style lang="scss" scoped>

</style>
